import { ILocalStorage } from '../contracts/storage.interface';

const storageTypes = {
  WEB_STORAGE: 'WEB_STORAGE',
  MOBILE_STORAGE: 'MOBILE_STORAGE'
};

const storageCache: { [key: string]: ILocalStorage } = {};

const initWebStorage = (storage: ILocalStorage) => {
  storageCache[storageTypes.WEB_STORAGE] = storage;
};

const initMobileStorage = (storage: ILocalStorage) => {
  storageCache[storageTypes.MOBILE_STORAGE] = storage;
};

const getStorage = (): ILocalStorage => {
  if (typeof document !== 'undefined') {
    return storageCache[storageTypes.WEB_STORAGE];
  } else if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return storageCache[storageTypes.MOBILE_STORAGE];
  } else {
    throw new Error('Nodejs environment is not supported');
  }
};

export { initWebStorage, initMobileStorage, getStorage };
